package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

// CV = chapter, verse
data class VerseReferenceCV(
    val chapter: Int,
    val verse: Int,
)
